const Navbar = () => {
    return (
        <header id="header" className="header d-flex align-items-center fixed-top">
            <div className="container position-relative d-flex align-items-center justify-content-between">

                <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
                    <img src="assets/images/logo/isotipo-blanco.png" alt="" />
                </a>

                <nav id="navmenu" className="navmenu">
                    <ul>
                        <li><a href="#hero" className="active">Inicio</a></li>
                        <li><a href="#about">Nosotros</a></li>
                        <li><a href="#services">Servicios</a></li>
                        <li><a href="#pricing">Membresías</a></li>
                        <li><a href="#contact">Contacto</a></li>
                        <li><a href="/login">Cliente</a></li>
                    </ul>
                    <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                </nav>

            </div>
        </header>
    )
}

export default Navbar;